import React from "react";

// Images
import { Api, Leadership } from "../../../../../../../assets/svg";

// Scss
import './ProductDocument.scss';


const products = [
    { id: 1, "productDocument": "API Document", icon: <Api /> },
    { id: 2, "productDocument": "Admin Document", icon: <Leadership /> }
]


interface IDocumentProps {
    onClick?: (lDocument: any) => void;
    title?: string
}

const handleKeyActivate = (callback: () => void) => (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        callback();
    }
};

function ProductDocument({ title, onClick, ...props }: IDocumentProps) {
    return (
        <div className="product-document">
            <div className="title">Documentation</div>
            <div className="middle">
                {
                    products.map((item, index) => (
                        <div
                            className="wrapper"
                            key={index}
                            role="button"
                            tabIndex={0}
                            aria-label={`Open ${item.productDocument}`}
                            onClick={() => onClick && onClick(item.productDocument)}
                            onKeyDown={handleKeyActivate(() => onClick && onClick(item.productDocument))}
                        >
                            <div className="icon-wrapper">{item.icon}</div>
                            <p className="product-title">{item.productDocument}</p>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default ProductDocument;